import { render, staticRenderFns } from "./KLolTeam.vue?vue&type=template&id=cdefaaba&scoped=true&"
import script from "./KLolTeam.vue?vue&type=script&lang=ts&"
export * from "./KLolTeam.vue?vue&type=script&lang=ts&"
import style0 from "./KLolTeam.vue?vue&type=style&index=0&id=cdefaaba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdefaaba",
  null
  
)

export default component.exports